import { Scissors } from "lucide-react";
import { fmtTime } from "./useVideoEditor";

/**
 * Trim sliders + preview-segment button.
 */
export default function TrimControls({
  duration, startSec, endSec, onStartChange, onEndChange, onPreview,
}) {
  return (
    <div className="glass rounded-2xl p-4">
      <div className="flex items-center gap-2 mb-3">
        <Scissors size={16} className="text-[#00E5FF]" />
        <div className="font-display font-bold">Trim</div>
        <span className="text-xs text-[#64748B] ml-auto">
          {fmtTime(startSec)} → {fmtTime(endSec)} of {fmtTime(duration)}
        </span>
      </div>
      <label className="text-xs uppercase tracking-[0.2em] text-[#64748B]">Start</label>
      <input
        type="range" min="0" max={duration || 100} step="0.1"
        value={startSec}
        onChange={(e) => onStartChange(Math.min(parseFloat(e.target.value), endSec - 0.1))}
        data-testid="trim-start"
        className="w-full accent-[#00E5FF]"
      />
      <label className="text-xs uppercase tracking-[0.2em] text-[#64748B]">End</label>
      <input
        type="range" min="0" max={duration || 100} step="0.1"
        value={endSec}
        onChange={(e) => onEndChange(Math.max(parseFloat(e.target.value), startSec + 0.1))}
        data-testid="trim-end"
        className="w-full accent-[#7B2CBF]"
      />
      <button
        data-testid="preview-segment"
        onClick={onPreview}
        className="mt-2 nexus-btn-secondary text-xs"
      >
        Preview segment
      </button>
    </div>
  );
}
